<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" >
        <flat-pickr
            ref="flat-pickr"
            v-model="inputValue"
            :placeholder="placeholder"
            :name="path"
            @blur="event => $emit('blur', event)"
            @on-close="event => $emit('close', event)"
            @on-change="event => $emit('change', event)"
            @input="event => $emit('input', event)"
            :config="config">
        </flat-pickr>
    </v-field>
</template>

<script>
    import mixins from './mixins'
    import 'flatpickr/dist/flatpickr.css'
    import flatPickr from 'vue-flatpickr-component';
    import { Spanish } from 'flatpickr/dist/l10n/es.js'

    export default {
        name: 'VDatetimePicker',

        mixins,

        props: {
            placeholder: String,
            maxDate: String,
            disableMobile: {
                type: Boolean,
                default: false
            }
        },

        components: {
            flatPickr
        },

        data() {
            return {
                inputValue: this.value || '',
                focus: false,
                config: {
                    dateFormat: 'd-m-Y',
                    locale: Spanish,
                    allowInput: true,
                    maxDate: this.maxDate,
                    disableMobile: this.disableMobile
                },
            }
        },

        watch:{
            inputValue(){
                if(this.inputValue !== null || this.inputValue !== ''){
                    this.focus = true
                }
            }
        },

        mounted() {
            this.$nextTick(() => {
                this.$refs['flat-pickr'].$el.autocomplete = 'off'
            })
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VDatetimePicker.vue